/* START_MODULE_CONTRACT
 * PURPOSE: Frontend API client для ролей проекта (CRUD).
 * SCOPE: HTTP-вызовы /api/projects/{id}/roles.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API, V-M-FE-API, M-PROJECT-ROLE
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * getProjectRoles - список ролей проекта.
 * createProjectRole - создать роль.
 * updateProjectRole - обновить роль.
 * deleteProjectRole - удалить роль.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: function contracts и парные END_METHOD.
 * END_CHANGE_SUMMARY
 */

import apiClient from './apiClient';

/* START_METHOD_getProjectRoles */
/* START_CONTRACT: getProjectRoles
 * PURPOSE: Получить список ролей проекта.
 * INPUTS: { projectId: number|string, signal: AbortSignal }
 * OUTPUTS: { Promise<AxiosResponse> - GET roles }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-ROLE
 * END_CONTRACT: getProjectRoles
 */
export function getProjectRoles(projectId, signal) {
  return apiClient.get(`/api/projects/${projectId}/roles`, { signal });
}
/* END_METHOD_getProjectRoles */

/* START_METHOD_createProjectRole */
/* START_CONTRACT: createProjectRole
 * PURPOSE: Создать роль проекта.
 * INPUTS: { projectId: number|string, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - POST role }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-ROLE
 * END_CONTRACT: createProjectRole
 */
export function createProjectRole(projectId, payload) {
  return apiClient.post(`/api/projects/${projectId}/roles`, payload);
}
/* END_METHOD_createProjectRole */

/* START_METHOD_updateProjectRole */
/* START_CONTRACT: updateProjectRole
 * PURPOSE: Обновить роль проекта.
 * INPUTS: { projectId, roleId, payload: object }
 * OUTPUTS: { Promise<AxiosResponse> - PUT role }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-ROLE
 * END_CONTRACT: updateProjectRole
 */
export function updateProjectRole(projectId, roleId, payload) {
  return apiClient.put(`/api/projects/${projectId}/roles/${roleId}`, payload);
}
/* END_METHOD_updateProjectRole */

/* START_METHOD_deleteProjectRole */
/* START_CONTRACT: deleteProjectRole
 * PURPOSE: Удалить роль проекта.
 * INPUTS: { projectId, roleId }
 * OUTPUTS: { Promise<AxiosResponse> - DELETE role }
 * SIDE_EFFECTS: HTTP-запрос к backend.
 * LINKS: M-PROJECT-ROLE
 * END_CONTRACT: deleteProjectRole
 */
export function deleteProjectRole(projectId, roleId) {
  return apiClient.delete(`/api/projects/${projectId}/roles/${roleId}`);
}
/* END_METHOD_deleteProjectRole */
